export const con = {
	adminUrl: '/admin/api/v1',
	uploadUrl: '/api/v1',
	notificationUrl: '/notification/api/v1',

	CATEGORY_CODE : window.process?.env?.REACT_APP_CATEGORY_CODE,
	GA_ID_DEV: window.process?.env?.REACT_APP_GA_ID_DEV,
	GA_ID_QA: window.process?.env?.REACT_APP_GA_ID_QA,
	GA_ID_PROD: window.process?.env?.REACT_APP_GA_ID_PROD,
	PUBLIC_URL: window.process?.env?.REACT_APP_CDN_HOST,
	PRIVACY_POLICY: window.process?.env?.REACT_APP_PRIVACY_POLICY,
	DIGITAL_HOST: window.process?.env?.REACT_APP_DIGITAL_HOST,
	REDIRECTION: window.process?.env?.REACT_APP_REDIRECTION,

	get PRODUCT_CODE() {
		return (window.process?.env?.REACT_APP_PRODUCT_CODE) || process.env.REACT_APP_PRODUCT_CODE;
	},
	get PRODUCT_TITLE() {
		return (window.process?.env?.REACT_APP_PRODUCT_TITLE) || process.env.REACT_APP_PRODUCT_TITLE;
	},
	get INSTITUTION_CODE() {
		return (window.process?.env?.REACT_APP_INSTITUTION_CODE) || process.env.REACT_APP_INSTITUTION_CODE;
	},
	get ENVIRONMENT() {
		return (window.process?.env?.REACT_APP_ENVIRONMENT) || process.env.REACT_APP_ENVIRONMENT;
	},
	get BULK_SSN_CAP() {
		return (window.process?.env?.REACT_APP_BULK_SSN_CAP) || process.env.REACT_APP_BULK_SSN_CAP;
	},
	auth: {
		summary: 'INST_USER,USER'
	},
	get fdsEndpoint() {
		return (window.process?.env?.REACT_APP_WEB_ENDPOINT) || process.env.REACT_APP_WEB_ENDPOINT;
	},
	get APP_FEATURES() {
		return (window.process?.env?.REACT_APP_FEATURES) || process.env.REACT_APP_FEATURES;
	},
};